import { Form } from 'antd';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import iconSetting from '../../assets/images/schedules/icon-setting.svg';
import { formattedPrice } from '../../lib/utils';
import { useAppDispatch } from '../../redux/hooks';
import { setListFare, setListLock } from '../../redux/slice/schdules/scheduleSlice';
import { calculateSegments, groupSegmentsByUnitsWithRowBreak } from '../../utils/helpers';
import { listColor } from '../../utils/listColorItem';
import LocationModal from './ModalSchedules/LocationModal';
import LockSegmentModal from './ModalSchedules/LockSegmentModal';
import PriceModal from './ModalSchedules/PriceModal';
import './Schedules.scss';

const SegmentRenderer = ({
  listSegment,
  listTransships,
  fares,
  locks,
  isDetailSchedule,
  listScheduleDetail,
  isDiagram,
  dataSchedule,
}: any) => {
  const [selectedRoute, setSelectedRoute] = useState<any>('');
  const [openModalLocation, setOpenModalLocation] = useState<boolean>(false);
  const [openModalPrice, setOpenModalPrice] = useState<boolean>(false);
  const [openModalLock, setOpenModalLock] = useState<boolean>(false);
  const [isLastItem, setIsLastItem] = useState<boolean>(false);
  const [isDetail, setIsDetail] = useState<boolean>(false);
  const [routeId, setRouteId] = useState<string>('');
  const [className, setClassName] = useState<string>('');
  const [priceRangeActive, setPriceRangeActive] = useState([]);
  const [lockItemActive, setLockItemActive] = useState([]);
  const [segmentActive, setSegmentActive] = useState<any>(1);
  const segments = calculateSegments(listSegment?.segment, false);
  const [formLocation] = Form.useForm();
  const dispatch = useAppDispatch();
  const groupedRowsByUnits = groupSegmentsByUnitsWithRowBreak(segments, false);

  const handleBlockClick = (from: any, to: any, className: string, isDetail: boolean) => {
    setOpenModalPrice(true);
    const routeId = `${from?.no}-${to?.no}`;
    setRouteId(routeId);
    setSelectedRoute(`${from?.name} - ${to?.name}`);
    setClassName(className);
    const fareActive = fares?.filter((item: any) => item?.route === routeId);
    if (isDetail) {
      setPriceRangeActive(fareActive);
    } else {
      setPriceRangeActive([]);
    }
  };
  const handleLockClick = (from: any, to: any, className: string) => {
    setOpenModalLock(true);
    const routeId = `${from?.no}-${to?.no}`;
    setRouteId(routeId);
    setSelectedRoute(`${from?.name} - ${to?.name}`);
    setClassName(className);
    const lockActive = locks?.filter((item: any) => item?.route === routeId);
    setLockItemActive(lockActive);
  };
  const handleSettingLocation = (index: number) => {
    setOpenModalLocation(true);
    const segmentActiveItem = listSegment?.segment?.length
      ? listSegment?.segment?.filter((item: any) => item?.no === index + 1)
      : [];
    if (index + 1 === listSegment?.segment?.length) {
      setIsLastItem(true);
    }
    setSegmentActive(segmentActiveItem);
  };
  const onFinishLocation = (values: any) => {
    if (listTransships) {
      const missingIds = Object.values(listTransships)?.some((group: any) =>
        Object.values(group)?.some((item: any) => item?.pickup_location_id === undefined),
      );
      if (missingIds) {
        toast.error('Vui lòng nhâp đủ điểm đón trả');
      } else {
        const allIds: any = Object.values(listTransships)?.reduce((acc: any, group: any) => {
          return acc?.concat(Object.values(group)?.map((item: any) => item?.pickup_location_id));
        }, []);
        const hasDuplicates = allIds?.some((id: any, index: number) => allIds?.indexOf(id) !== index);
        if (!hasDuplicates) {
          setOpenModalLocation(false);
        } else {
          toast.error('Vui lòng không nhập điểm đón trả trùng nhau');
        }
      }
    }
  };

  useEffect(() => {
    if (isDetailSchedule) {
      if (
        listScheduleDetail?.segments?.stops?.length === listSegment?.segment?.length &&
        listScheduleDetail?.bus_type?.id === listSegment?.bus_type_id
      ) {
        const allFormattedData = Object?.keys(groupedRowsByUnits)?.flatMap((unit) =>
          groupedRowsByUnits[unit]?.flatMap((row: any) =>
            row?.map((segment: any) => {
              const dataPriceItem = listScheduleDetail?.segments?.data?.find(
                (price: any) =>
                  price?.start_location?.name === segment?.from?.name &&
                  price?.end_location?.name === segment?.to?.name,
              );
              const priceRange = dataPriceItem?.fare
                ?.filter((fareItem: any) => fareItem?.group_name && fareItem?.type === 'diagram')
                ?.map((fareItem: any) => ({
                  name: fareItem?.group_name,
                  price: formattedPrice(fareItem?.price),
                }));
              const priceCommon = dataPriceItem?.fare
                ?.filter((fareItem: any) => fareItem?.group_name && fareItem?.type === 'common')
                ?.map((fareItem: any) => ({
                  name: fareItem?.group_name,
                  price: formattedPrice(fareItem?.price),
                  amount: fareItem?.amount,
                }));
              const formattedFare = {
                route: `${segment?.from?.no}-${segment?.to?.no}`,
                price_range: priceRange,
                price_common: priceCommon,
              };
              const formattedLock = {
                route: `${segment?.from?.no}-${segment?.to?.no}`,
                status: {
                  agent: dataPriceItem?.is_agent_lock,
                  api: dataPriceItem?.is_api_lock,
                  company: dataPriceItem?.is_company_lock,
                },
              };

              return { formattedFare, formattedLock };
            }),
          ),
        );
        const allFormattedDataFare = allFormattedData
          ?.map((item) => item?.formattedFare)
          ?.filter((fare) => fare?.price_range?.length > 0);
        const allFormattedDataLock = allFormattedData?.map((item) => item?.formattedLock);
        dispatch(setListFare(allFormattedDataFare));
        dispatch(setListLock(allFormattedDataLock));
      } else {
        const allFormattedData = Object?.keys(groupedRowsByUnits)?.flatMap((unit) =>
          groupedRowsByUnits[unit]?.flatMap((row: any) =>
            row?.map((segment: any) => {
              const dataPriceItem = listSegment?.segments?.data?.find(
                (price: any) =>
                  price?.start_location?.name === segment?.from?.name &&
                  price?.end_location?.name === segment?.to?.name,
              );
              const priceRange = dataPriceItem?.fare
                ?.filter((fareItem: any) => fareItem?.group_name && fareItem?.type === 'diagram')
                .map((fareItem: any) => ({
                  name: fareItem?.group_name,
                  price: formattedPrice(fareItem?.price),
                }));
              const priceCommon = dataPriceItem?.fare
                ?.filter((fareItem: any) => fareItem?.group_name && fareItem?.type === 'common')
                ?.map((fareItem: any) => ({
                  name: fareItem?.group_name,
                  price: formattedPrice(fareItem?.price),
                  amount: fareItem?.amount,
                }));
              const formattedFare = {
                route: `${segment?.from?.no}-${segment?.to?.no}`,
                price_range: priceRange,
                price_common: priceCommon,
              };
              const formattedLock = {
                route: `${segment?.from?.no}-${segment?.to?.no}`,
                status: {
                  agent: dataPriceItem?.is_agent_lock,
                  api: dataPriceItem?.is_api_lock,
                  company: dataPriceItem?.is_company_lock,
                },
              };

              return { formattedFare, formattedLock };
            }),
          ),
        );
        const allFormattedDataFare = allFormattedData
          ?.map((item) => item?.formattedFare)
          ?.filter((fare) => fare?.price_range?.length > 0);
        const allFormattedDataLock = allFormattedData?.map((item) => item?.formattedLock);
        dispatch(setListFare(allFormattedDataFare));
        dispatch(setListLock(allFormattedDataLock));
      }
    }
  }, [isDetailSchedule, dataSchedule, listSegment]);
  return (
    <div className="segment-render-container">
      <div className="w-max">
        <div className="bottom-title">
          <div
            className="d-flex w-fit"
            style={{
              padding: '0 0 0 24px',
            }}
          >
            {listSegment?.segment?.length
              ? listSegment?.segment?.map((item: any, index: number) => (
                  <div
                    key={index}
                    style={{
                      width: index === listSegment?.segment?.length - 1 ? 'max-content' : '248px',
                      marginRight: index === listSegment?.segment?.length - 2 ? 24 : 4,
                    }}
                    className="d-flex items-center"
                  >
                    <div
                      style={{}}
                      className="d-flex items-center cursor-pointer w-fit title-segment price"
                      onClick={() => handleSettingLocation(index)}
                    >
                      {item?.name}
                      <img src={iconSetting} alt="" width={12} height={12} />
                    </div>
                  </div>
                ))
              : ''}
          </div>
        </div>
        <div className="segment-render-block">
          <div className="segment-render-content">
            {Object.keys(groupedRowsByUnits)?.map((unit, index: number) => (
              <div key={`unit-${index}`}>
                {groupedRowsByUnits[unit]?.map((row: any, rowIndex: number) => (
                  <div key={rowIndex} className="segment-render-item block-bg-color-200">
                    {row.map((segment: any, index: number) => {
                      const routePriceItem = fares?.find((fare: any) => fare?.route === segment?.routeId);
                      const lockPriceItem = locks?.find((lock: any) => lock?.route === segment?.routeId);
                      return (
                        <>
                          {routePriceItem && routePriceItem?.price_range?.length ? (
                            <div
                              key={index}
                              className={`d-flex items-center justify-center block-segment-item segment-render btn-time-line 
                                   ${listColor[(segment?.index + 1) % listColor?.length]}`}
                              style={{
                                width: segment.width + (segment.units - 1) * 8,
                                marginRight: index === listSegment?.segment?.length - 2 ? 0 : 8,
                                marginLeft: segment.marginLeft || 0,
                              }}
                            >
                              <div className={`w-100 ${listColor[(segment?.index + 1) % listColor?.length]}`}>
                                <div className="w-100 d-flex  justify-between items-start">
                                  <div className={`${segment?.units > 1 ? 'd-flex gap-x-2' : ''} w-90`}>
                                    <>
                                      {routePriceItem?.price_range?.map((price_range: any, index: number) => (
                                        <div key={`block-item-${index}`}>
                                          <div className="block-price-item">
                                            {`${price_range?.name}: `}
                                            <span
                                              className={`color-700 ${
                                                listColor[(segment?.index + 1) % listColor?.length]
                                              }`}
                                            >{`${price_range?.price} `}</span>
                                            đ
                                            <br />
                                          </div>
                                        </div>
                                      ))}
                                    </>
                                    {routePriceItem?.price_common && routePriceItem?.price_common?.length
                                      ? routePriceItem?.price_common?.map((priceCommon: any, index: number) => (
                                          <div key={`block-not-diagram-${index}`}>
                                            <div className="block-price-item">
                                              {`${priceCommon?.name}(KSĐ): `}
                                              <span
                                                className={`color-700 ${
                                                  listColor[(segment?.index + 1) % listColor?.length]
                                                }`}
                                              >{`${priceCommon?.price} `}</span>
                                              đ
                                              <br />
                                            </div>
                                          </div>
                                        ))
                                      : ''}
                                  </div>
                                  <div>
                                    {lockPriceItem?.status?.agent ||
                                    lockPriceItem?.status?.api ||
                                    lockPriceItem?.status?.company ? (
                                      <div>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          onClick={() =>
                                            handleLockClick(
                                              segment.from,
                                              segment.to,
                                              `${listColor[(segment?.index + 1) % listColor?.length]}`,
                                            )
                                          }
                                        >
                                          <path
                                            d="M10.0002 1.66663C11.1052 1.66663 12.165 2.10561 12.9464 2.88701C13.7278 3.66842 14.1668 4.72822 14.1668 5.83329V8.33329C14.8299 8.33329 15.4658 8.59668 15.9346 9.06553C16.4034 9.53437 16.6668 10.1703 16.6668 10.8333V15.8333C16.6668 16.4963 16.4034 17.1322 15.9346 17.6011C15.4658 18.0699 14.8299 18.3333 14.1668 18.3333H5.8335C5.17045 18.3333 4.53457 18.0699 4.06573 17.6011C3.59689 17.1322 3.3335 16.4963 3.3335 15.8333V10.8333C3.3335 10.1703 3.59689 9.53437 4.06573 9.06553C4.53457 8.59668 5.17045 8.33329 5.8335 8.33329V5.83329C5.8335 4.72822 6.27248 3.66842 7.05388 2.88701C7.83529 2.10561 8.89509 1.66663 10.0002 1.66663ZM10.0002 11.6666C9.57968 11.6665 9.17469 11.8253 8.86637 12.1112C8.55805 12.3971 8.3692 12.789 8.33766 13.2083L8.3335 13.3333C8.3335 13.6629 8.43124 13.9852 8.61438 14.2592C8.79752 14.5333 9.05781 14.7469 9.36236 14.8731C9.6669 14.9992 10.002 15.0322 10.3253 14.9679C10.6486 14.9036 10.9456 14.7449 11.1787 14.5118C11.4118 14.2787 11.5705 13.9817 11.6348 13.6584C11.6991 13.3351 11.6661 13 11.54 12.6955C11.4138 12.3909 11.2002 12.1306 10.9261 11.9475C10.652 11.7644 10.3298 11.6666 10.0002 11.6666ZM10.0002 3.33329C9.33712 3.33329 8.70124 3.59668 8.2324 4.06553C7.76355 4.53437 7.50016 5.17025 7.50016 5.83329V8.33329H12.5002V5.83329C12.5002 5.17025 12.2368 4.53437 11.7679 4.06553C11.2991 3.59668 10.6632 3.33329 10.0002 3.33329Z"
                                            className={`color-700 fill ${
                                              listColor[(segment?.index + 1) % listColor?.length]
                                            }`}
                                          />
                                        </svg>
                                      </div>
                                    ) : (
                                      <div className={`${segment?.units > 1 ? 'd-flex items-center gap-x-2' : ''}`}>
                                        <div>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            onClick={() => {
                                              setIsDetail(true);
                                              handleBlockClick(
                                                segment.from,
                                                segment.to,
                                                `${listColor[(segment?.index + 1) % listColor?.length]}`,
                                                true,
                                              );
                                            }}
                                          >
                                            <path
                                              d="M4.91777 12.9241L4.18457 15.8569L7.11735 15.1237L15.6121 6.62892C15.8871 6.35394 16.0415 5.98102 16.0415 5.59219C16.0415 5.20335 15.8871 4.83044 15.6121 4.55545L15.486 4.42934C15.211 4.15443 14.8381 4 14.4493 4C14.0605 4 13.6876 4.15443 13.4126 4.42934L4.91777 12.9241Z"
                                              stroke="#BE123C"
                                              stroke-width="1.66667"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              className={`color-700 fill ${
                                                listColor[(segment?.index + 1) % listColor?.length]
                                              }`}
                                            />
                                            <path
                                              d="M4.91777 12.9242L4.18457 15.857L7.11735 15.1238L14.4493 7.79187L12.2497 5.59229L4.91777 12.9242Z"
                                              fill="#BE123C"
                                              className={`color-700 fill ${
                                                listColor[(segment?.index + 1) % listColor?.length]
                                              }`}
                                            />
                                            <path
                                              className={`color-700 fill ${
                                                listColor[(segment?.index + 1) % listColor?.length]
                                              }`}
                                              d="M12.2491 5.59229L14.4487 7.79187M10.7827 15.857H16.6483"
                                              stroke="#BE123C"
                                              stroke-width="1.66667"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                        </div>
                                        <div>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            onClick={() =>
                                              handleLockClick(
                                                segment.from,
                                                segment.to,
                                                `${listColor[(segment?.index + 1) % listColor?.length]}`,
                                              )
                                            }
                                          >
                                            <path
                                              className={`color-700 fill ${
                                                listColor[(segment?.index + 1) % listColor?.length]
                                              }`}
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M5.43858 3.35527C4.13956 3.35527 2.94316 4.43304 2.94316 5.79752V8.35275H1.24316V5.79752C1.24316 3.41019 3.2869 1.65527 5.43858 1.65527C7.51453 1.65527 9.60321 3.36528 9.60321 5.79752V8.35275H7.90321V5.79752C7.90321 4.40262 6.67723 3.35527 5.43858 3.35527Z"
                                              fill="#0F766E"
                                            />
                                            <path
                                              className={`color-700 fill ${
                                                listColor[(segment?.index + 1) % listColor?.length]
                                              }`}
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M7.92334 8.34448C6.54263 8.34448 5.42334 9.46377 5.42334 10.8445V15.8447C5.42334 17.2254 6.54263 18.3447 7.92334 18.3447H16.2568C17.6375 18.3447 18.7568 17.2254 18.7568 15.8447V10.8445C18.7568 9.46377 17.6375 8.34448 16.2568 8.34448H7.92334ZM12.0896 15.0337C13.0182 15.0337 13.771 14.2809 13.771 13.3523C13.771 12.4237 13.0182 11.6709 12.0896 11.6709C11.161 11.6709 10.4082 12.4237 10.4082 13.3523C10.4082 14.2809 11.161 15.0337 12.0896 15.0337Z"
                                              fill="#0F766E"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div
                              key={index}
                              className={`d-flex items-center justify-center block-segment-item segment-render  btn-time-line 
                                ${listColor[(segment?.index + 1) % listColor?.length]}`}
                              style={{
                                minWidth: segment.width + (segment.units - 1) * 8,
                                marginRight: index === listSegment?.segment?.length - 2 ? 0 : 8,
                                marginLeft: segment.marginLeft || 0,
                              }}
                              onClick={() => {
                                setIsDetail(false);
                                handleBlockClick(
                                  segment.from,
                                  segment.to,
                                  `${listColor[(segment?.index + 1) % listColor?.length]}`,
                                  false,
                                );
                              }}
                            >
                              <div className="d-flex justify-content-center items-center w-100">
                                <span
                                  className={`fs-14 fw-600 color-700 ${
                                    listColor[(segment?.index + 1) % listColor?.length]
                                  }`}
                                >
                                  Thêm giá vé
                                </span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="17"
                                  height="16"
                                  viewBox="0 0 17 16"
                                  fill="none"
                                  className={`color-700 ${listColor[(segment?.index + 1) % listColor?.length]}`}
                                >
                                  <path
                                    d="M4.5 8H12.5"
                                    className={`color-700 ${listColor[(segment?.index + 1) % listColor?.length]}`}
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M8.5 4V12"
                                    className={`color-700 ${listColor[(segment?.index + 1) % listColor?.length]}`}
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            </div>
                          )}
                        </>
                      );
                    })}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Form
        layout="vertical"
        form={formLocation}
        onFinish={onFinishLocation}
        autoComplete="off"
        validateTrigger="onSubmit"
        name="segment-setting-form"
        colon={false}
        labelCol={{ span: 12 }}
        labelAlign={'left'}
        labelWrap
      >
        <LocationModal
          modalOpen={openModalLocation}
          onCancel={() => {
            setOpenModalLocation(false);
            setIsLastItem(false);
            setSegmentActive(1);
          }}
          // formLocation={form}
          onOk={() => {
            setSegmentActive(1);
          }}
          isLastItem={isLastItem}
          segmentActive={segmentActive}
          listTransships={listTransships}
        />
        <LockSegmentModal
          modalOpen={openModalLock}
          route={selectedRoute}
          routeId={routeId}
          onCancel={() => {
            setOpenModalLock(false);
            setRouteId('');
            setSelectedRoute(``);
            setClassName('');
            setPriceRangeActive([]);
          }}
          onOk={() => {}}
          className={className}
          lockItemActive={lockItemActive}
        />
      </Form>
      <PriceModal
        modalOpen={openModalPrice}
        onCancel={() => {
          setOpenModalPrice(false);
          setRouteId('');
          setSelectedRoute(``);
          setClassName('');
          setPriceRangeActive([]);
        }}
        onOk={() => {}}
        route={selectedRoute}
        routeId={routeId}
        className={className}
        isDetail={isDetail}
        listTypeBus={listSegment}
        priceRangeActive={priceRangeActive}
        isDiagram={isDiagram}
      />
    </div>
  );
};

export default SegmentRenderer;
